import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmation!',
  message = 'Are you sure you want to proceed?',
  confirmText = 'CONFIRM',
  cancelText = 'CANCEL',
}) => {
  const handleClose = () => onClose();

  const handleConfirm = (e) => {
    handleClose();
    if (onConfirm) onConfirm(e);
  };

  return (
    <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
      {isOpen && (
        <div className="modal">
          {/* Header */}
          <div className="popUp-header row">
            <div className="popUp-title">
              <h3 style={{ color: '#668fca' }}>{title}</h3>
            </div>
            <div className="popUp-close">
              <CloseIcon onClick={handleClose} />
            </div>
          </div>

          {/* Body */}
          <div
            className="popUp-body"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              padding: '20px 10px',
            }}
          >
            <span>{message}</span>
          </div>

          {/* Buttons */}
          <div
            className="buttons row"
            style={{
              justifyContent: 'center',
              padding: '20px 40px 30px 40px',
              gap: '10px',
            }}
          >
            <button
              className="save row"
              onClick={handleConfirm}
              style={{
                backgroundColor: '#2563eb',
                color: '#fff',
                border: 'none',
                borderRadius: '6px',
                padding: '6px 16px',
                cursor: 'pointer',
                fontWeight: 500,
              }}
            >
              {confirmText}
            </button>
            <button
              className="cancel row"
              onClick={handleClose}
              style={{
                backgroundColor: '#e5e7eb',
                color: '#111827',
                border: 'none',
                borderRadius: '6px',
                padding: '6px 16px',
                cursor: 'pointer',
                fontWeight: 500,
              }}
            >
              {cancelText}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}